export const new_unit_order = `subscription new_unit_order{
    new_unit_order{
        transaction_code
        status
        direction
        security{
            short_name
            name
            stock_market_locality
            currency{
                currency
                name
                decimal
            }
        }
        count
        fulfilled_count
        validity_start
        validity_end
        deal_price
        purchase_value
    }
}`;
